import { AuthError, InteractionRequiredAuthError } from "@azure/msal-browser";
import { useAccount } from "@azure/msal-react";
import React, { FunctionComponent } from "react";
import { useEffect } from "react";
import { scopes } from "../../../b2cConfiguration";
import { useUserProfile } from "../../../support/custom-hooks/useUserProfile";
import { useDispatch } from "react-redux";
import { clearUserProfile } from "../../../store/actions/usersActions";
import { clearProfileCache } from "../../../services/Users.Service";
import { clearReferralStatusesCache } from "../../../services/ReferralStatuses.Service";

export const AuthenticationVerifier: FunctionComponent<any> = ({ accounts, instance, children }) => {
    const account = useAccount(accounts[0]);
    const [isTokenSavedState, setIsTokenSavedState] = React.useState(false);
    const dispatch = useDispatch();
    
    // Use the custom hook instead of calling getProfile directly
    const { isLoaded } = useUserProfile();

    useEffect(() => {
        if (account) {
            instance.acquireTokenSilent({
                scopes: scopes,
                account: account
            }).then((response) => {
                if (response) {
                    window.sessionStorage.setItem("Authorization", `Bearer ${response.accessToken}`);
                    window.sessionStorage.setItem("X-Tenant-Authorization", `${response.idToken}`);
                    setIsTokenSavedState(true);
                }
            }).catch(async (error) => {
                if (error instanceof AuthError) {
                    // Clear all caches and Redux state before logout
                    dispatch(clearUserProfile());
                    clearProfileCache();
                    clearReferralStatusesCache();
                    window.sessionStorage.setItem("Authorization", '');
                    window.sessionStorage.setItem("X-Tenant-Authorization", '');
                    instance.logout();
                    window.location.reload();
                }
                else if (error instanceof InteractionRequiredAuthError) {
                    return instance.acquireTokenPopup({
                        scopes: scopes,
                        account: account
                    });
                }
            }).catch(error => {
                console.error('Authentication error:', error);
            });
        }
    }, [account, instance]);

    // The profile loads automatically through the useUserProfile hook
    // No need to call getProfile manually here

    if (isTokenSavedState && isLoaded){
        return children;   
    }
    return '';
}
